module.exports = __webpack_public_path__ + "img/xinlang.6fa8efb1.png";